import { render, staticRenderFns } from "./SwiperItem.vue?vue&type=template&id=5a28aeed&scoped=true&"
import script from "./SwiperItem.vue?vue&type=script&lang=js&"
export * from "./SwiperItem.vue?vue&type=script&lang=js&"
import style0 from "./SwiperItem.vue?vue&type=style&index=0&id=5a28aeed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28aeed",
  null
  
)

export default component.exports